export const LOSE = 'Lose';
